const SELECTED_IMPLEMENTATION_KEY = 'selected_implementation';
const SELECTED_ENTITIES_API_URL_KEY = 'selected_entities_api_url';

const PLACEHOLDER_VALUES = ['PER_ENVIRONMENT_SETTING'];

function isPlaceholderValue(value) {
    if (!value) {
        return true;
    }

    const normalized = value.toString().trim();
    if (!normalized) {
        return true;
    }

    if (PLACEHOLDER_VALUES.includes(normalized)) {
        return true;
    }

    // CI/CD placeholder format, e.g. __REACT_QUERY_API_URL__
    if (/^__.*__$/.test(normalized)) {
        return true;
    }

    return false;
}

function getDefaultEntitiesApiUrl() {
    const value = process.env.REACT_APP_DEFAULT_GENESYSENTITIES_API_URL || process.env.REACT_APP_GENESYSENTITIES_API_URL || '';
    return isPlaceholderValue(value) ? '' : value;
}

function getQueryApiUrl() {
    const value = process.env.REACT_APP_QUERY_API_URL || '';
    return isPlaceholderValue(value) ? '' : value;
}

function sanitizeApiUrl(url) {
    return isPlaceholderValue(url) ? '' : url;
}

const implementationConfigMap = {
    genesys: {
        entitiesApiUrl: getDefaultEntitiesApiUrl(),
    },
    staticgenesys: {
        entitiesApiUrl: sanitizeApiUrl(process.env.REACT_APP_STATIC_GENESYSENTITIES_API_URL) || getDefaultEntitiesApiUrl(),
    },
    staticlist: {
        entitiesApiUrl: sanitizeApiUrl(process.env.REACT_APP_STATIC_LISTS_API_URL) || getDefaultEntitiesApiUrl(),
    },
};

function normalizeImplementation(implementation) {
    return (implementation || '').toString().trim().toLowerCase();
}

export function getConfigForImplementation(implementation) {
    const normalizedImplementation = normalizeImplementation(implementation);
    if (!normalizedImplementation) {
        return null;
    }

    const config = implementationConfigMap[normalizedImplementation];
    if (!config?.entitiesApiUrl) {
        return null;
    }

    return {
        implementation: normalizedImplementation,
        entitiesApiUrl: config.entitiesApiUrl,
    };
}

export function setSelectedImplementationConfig(implementation) {
    const config = getConfigForImplementation(implementation);

    if (!config) {
        sessionStorage.removeItem(SELECTED_IMPLEMENTATION_KEY);
        sessionStorage.removeItem(SELECTED_ENTITIES_API_URL_KEY);
        return '';
    }

    sessionStorage.setItem(SELECTED_IMPLEMENTATION_KEY, config.implementation);
    sessionStorage.setItem(SELECTED_ENTITIES_API_URL_KEY, config.entitiesApiUrl);
    return config.entitiesApiUrl;
}

export function setDefaultApiConfig() {
    const defaultConfig = getConfigForImplementation('genesys');
    if (!defaultConfig) {
        sessionStorage.removeItem(SELECTED_IMPLEMENTATION_KEY);
        sessionStorage.removeItem(SELECTED_ENTITIES_API_URL_KEY);
        return '';
    }

    sessionStorage.setItem(SELECTED_IMPLEMENTATION_KEY, defaultConfig.implementation);
    sessionStorage.setItem(SELECTED_ENTITIES_API_URL_KEY, defaultConfig.entitiesApiUrl);
    return defaultConfig.entitiesApiUrl;
}

export function getSelectedImplementation() {
    return sessionStorage.getItem(SELECTED_IMPLEMENTATION_KEY) || 'genesys';
}

export function getSelectedEntitiesApiUrl() {
    const selected = sanitizeApiUrl(sessionStorage.getItem(SELECTED_ENTITIES_API_URL_KEY));
    return selected || getDefaultEntitiesApiUrl();
}

export function getSelectedQueryApiUrl() {
    return getQueryApiUrl();
}
